import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import store from "./store/store";
import { Provider } from "react-redux";

import { setOptions} from "@googlemaps/js-api-loader";
// 1. Set options (can be done once, anywhere before importing)
setOptions({
  key: "AIzaSyDwAZ5j5Dfg8iFxgdqvtrbrFh4RkYaz_1M",
  version: "weekly",
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={ store }>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
